<template>
  <Wrapper :type="type" @delete="$emit('delete')">
    <v-btn
      slot="preview"
      v-text="data.actionItem.text"
      style="text-transform: inherit"
    />
    <v-layout slot="edition" wrap row>
      <v-flex xs12>
        <v-text-field
          :value="data.actionItem.text"
          label="Text"
          outline
          @input="setValue(data.actionItem, 'text', $event)"
        ></v-text-field>
      </v-flex>
      <v-flex xs12>
        <icon-picker
          :value="data.actionItem.icon"
          label="Icon"
          outline
          @input="setValue(data.actionItem, 'icon', $event)"
        />
      </v-flex>
      <v-flex xs12>
        <v-layout wrap row>
          <v-flex xs12 sm3>
            <ActionType v-model="data.actionItem.action.type" />
          </v-flex>
          <v-flex xs12 sm9>
            <ActionLink
              v-model="data.actionItem.action.link"
              :type="data.actionItem.action.type"
              @clearLink="$delete(data.actionItem.action, 'link')"
            />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </Wrapper>
</template>

<script>
import Wrapper from "../../components/widgets/Wrapper";
import ActionLink from "../../components/ActionLink";
import ActionType from "../../components/ActionType";

export default {
  name: "WidgetButton",
  components: {
    Wrapper,
    ActionLink,
    ActionType
  },
  model: {
    prop: "data"
  },
  props: {
    type: {
      type: String,
      required: true
    },
    data: {
      type: Object,
      required: true
    }
  },
  methods: {
    setValue(obj, prop, value) {
      obj[prop] = value;
      this.$emit("input", this.data);
    }
  }
};
</script>
